import { useState } from "react";

const PlotLayoutPage = () => {
  const [selectedPlotId, setSelectedPlotId] = useState("");
  const [hoveredPlotId, setHoveredPlotId] = useState("");
  const [showPlotDetail, setShowPlotDetail] = useState(false);
  const [selectedPlotData, setSelectedPlotData] = useState("");
  const [showBookingForm, setShowBookingForm] = useState(false);

  const plotData = [
    // Row 1
    {
      id: 14,
      status: "available",
      sides: { top: 42.0, right: 32, bottom: 42.0, left: 35 },
      position: { x: 106, y: 43 },
      shouldReverse: true,
    },
    {
      id: 13,
      status: "booked",
      sides: { top: 38.0, right: 29, bottom: 40.0, left: 32.0 },
      position: { x: 148, y: 43 },
      shouldReverse: true,
    },

    //long
    {
      id: "",
      status: "",
      sides: { top: 173.5, right: 8.0, bottom: 174, left: 8.0 },
      position: { x: 12, y: 51 },
      shouldReverse: true,
    },

    // Row 2
    {
      id: 9,
      status: "available",
      sides: { top: 52.0, right: 34.0, bottom: 52.0, left: 34 },
      position: { x: 12, y: 85 },
      shouldReverse: true,
    },
    {
      id: 10,
      status: "available",
      sides: { top: 42.0, right: 34.0, bottom: 42.0, left: 34.0 },
      position: { x: 64, y: 85 },
      shouldReverse: true,
    },
    {
      id: 11,
      status: "available",
      sides: { top: 42.0, right: 34.0, bottom: 42.0, left: 34.0 },
      position: { x: 106, y: 85 },
      shouldReverse: true,
    },
    {
      id: 12,
      status: "available",
      sides: { top: 36.0, right: 34.0, bottom: 38.0, left: 34.0 },
      position: { x: 148, y: 85 },
      shouldReverse: true,
    },

    // Row 3
    {
      id: 8,
      status: "available",
      sides: { top: 52.0, right: 34.0, bottom: 52.0, left: 34.0 },
      position: { x: 12, y: 119 },
      shouldReverse: true,
    },
    {
      id: 7,
      status: "booked",
      sides: { top: 42.0, right: 34.0, bottom: 42.0, left: 34.0 },
      position: { x: 64, y: 119 },
      shouldReverse: true,
    },
    {
      id: 6,
      status: "booked",
      sides: { top: 42.0, right: 34.0, bottom: 42.0, left: 34.0 },
      position: { x: 106, y: 119 },
      shouldReverse: true,
    },
    {
      id: 5,
      status: "available",
      sides: { top: 34.0, right: 34.0, bottom: 36.0, left: 34.0 },
      position: { x: 148, y: 119 },
      shouldReverse: true,
    },

    //long
    {
      id: "",
      status: "",
      sides: { top: 169.0, right: 7.2, bottom: 169.5, left: 7.0 },
      position: { x: 12, y: 126 },
      shouldReverse: true,
    },

    // Row 4
    {
      id: 1,
      status: "booked",
      sides: { top: 52.0, right: 34.0, bottom: 52.0, left: 34.0 },
      position: { x: 12, y: 160 },
      shouldReverse: true,
    },
    {
      id: 2,
      status: "available",
      sides: { top: 42.0, right: 34.0, bottom: 42.0, left: 34.0 },
      position: { x: 64, y: 160 },
      shouldReverse: true,
    },
    {
      id: 3,
      status: "available",
      sides: { top: 42.0, right: 34.0, bottom: 42.0, left: 34.0 },
      position: { x: 106, y: 160 },
      shouldReverse: true,
    },
    {
      id: 4,
      status: "booked",
      sides: { top: 31.0, right: 34.0, bottom: 33, left: 34.0 },
      position: { x: 148, y: 160 },
      shouldReverse: true,
    },
  ];

  // Scale factor to increase plot sizes
  const sizeMultiplier = 1; // Increase this to make plots larger

  return (
    <>
      <div className="position-relative justify-content-center align-items-center min-vh-100 bg-white ">
        <div className="container pt-4">
          <div className="row g-2">
            <div className="col-md-3 col-6">
              <div className="bg-success bg-opacity-25 rounded p-2 text-center ">
                <strong>District</strong>
                <div>DINDIGUL</div>
              </div>
            </div>
            <div className="col-md-3 col-6">
              <div className="bg-success bg-opacity-25 rounded p-2 text-center ">
                <strong>Taluk</strong>
                <div>KODAIKANAL</div>
              </div>
            </div>
            <div className="col-md-3 col-6">
              <div className="bg-success bg-opacity-25 rounded p-2 text-center ">
                <strong>Village</strong>
                <div>KOOKKAL</div>
              </div>
            </div>
            <div className="col-md-3 col-6">
              <div className="bg-success bg-opacity-25 rounded p-2 text-center ">
                <strong>Survey No</strong>
                <div>528/1,2,3 PART</div>
              </div>
            </div>
          </div>
        </div>

        <div className="position-relative z-1 d-flex px-5 w-100 h-100 overflow-visible">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="-20 -20 290 200"
            preserveAspectRatio="xMidYMid meet"
            style={{
              height: "100%",
              width: "100%",
              maxHeight: "95vh",
              maxWidth: "50vw",
            }}
          >
            {/* Main land outline */}
            <path
              d="M 12 42.5 H 12 L 12 169 L 38 169 L 56 160 L 61 174 L 113 170 L 148 160 L 169 169 L 168 154 L 233 149 L 258 70 L 248 19 L 105 8 L 89 1 L 77 54 Z L 21 17 L 21 0 L 0 0 L -11 42.5 L -8 169"
              stroke="#000000"
              strokeWidth=".5"
              fill="none"
            />
            {/* Render plots */}
            {plotData.map((plot) => {
              const isSelected = selectedPlotId === plot.id;
              const isHovered = hoveredPlotId === plot.id;

              const fillColor = isSelected
                ? "white"
                : isHovered
                ? plot.status === "booked"
                  ? "rgba(255, 0, 0, 0.3)"
                  : "rgba(0, 255, 0, 0.3)"
                : "transparent";

              return (
                <g
                  key={plot.id}
                  transform={`translate(${plot.position.x}, ${plot.position.y})`}
                >
                  <g transform={plot.shouldReverse ? "scale(1, -1)" : ""}>
                    <polygon
                      points={`
                      0,0
                      ${plot.sides.top * sizeMultiplier},0
                      ${plot.sides.bottom * sizeMultiplier},${
                        plot.sides.right * sizeMultiplier
                      }
                      0,${plot.sides.left * sizeMultiplier}
                    `}
                      fill={fillColor}
                      stroke="black"
                      strokeWidth="0.5"
                      onClick={() => {
                        setSelectedPlotId(plot.id);
                        setSelectedPlotData(plot);
                        setShowPlotDetail(true);
                      }}
                      onMouseEnter={() => setHoveredPlotId(plot.id)}
                      onMouseLeave={() => setHoveredPlotId(null)}
                      style={{ cursor: "pointer" }}
                    />
                  </g>
                  <g transform={plot.shouldReverse ? "scale(1,1)" : ""}>
                    <text
                      x={
                        ((plot.sides.top + plot.sides.bottom) / 10) *
                        sizeMultiplier
                      }
                      y={
                        ((plot.sides.right + plot.sides.left) / -10) *
                        sizeMultiplier
                      }
                      fontSize="4"
                      fontWeight="bold"
                      fill="#000"
                      textAnchor="middle"
                      dominantBaseline="middle"
                    >
                      {plot.id}
                    </text>
                  </g>
                </g>
              );
            })}
            <text x="0.5%" y="11%" fontSize="4" writingMode="vertical-rl">
              Palam puthur ―――― Valanation Existing road ――――― Kookal
            </text>
            {/* Table Header */}
            <text x="70%" y="20%" fontSize="4" fontWeight="bold">
              Plot
            </text>
            <text x="76%" y="20%" fontSize="4" fontWeight="bold">
              Count
            </text>
            <text x="71%" y="23%" fontSize="4">
              1.
            </text>
            <text x="76%" y="23%" fontSize="4">
              25
            </text>
            <text x="71%" y="26%" fontSize="4">
              2.
            </text>
            <text x="76%" y="26%" fontSize="4">
              23½
            </text>
            <text x="71%" y="29%" fontSize="4">
              3.
            </text>
            <text x="76%" y="29%" fontSize="4">
              23½
            </text>
            <text x="71%" y="32%" fontSize="4">
              4.
            </text>
            <text x="76%" y="32%" fontSize="4">
              20
            </text>

            <text x="71%" y="35%" fontSize="4">
              5.
            </text>
            <text x="76%" y="35%" fontSize="4">
              22¾
            </text>
            <text x="71%" y="38%" fontSize="4">
              6.
            </text>
            <text x="76%" y="38%" fontSize="4">
              23½
            </text>
            <text x="71%" y="41%" fontSize="4">
              7.
            </text>
            <text x="76%" y="41%" fontSize="4">
              23½
            </text>
            <text x="71%" y="44%" fontSize="4">
              8.
            </text>
            <text x="76%" y="44%" fontSize="4">
              28
            </text>

            <text x="71%" y="47%" fontSize="4">
              9.
            </text>
            <text x="76%" y="47%" fontSize="4">
              30¼
            </text>
            <text x="71%" y="50%" fontSize="4">
              10.
            </text>
            <text x="76%" y="50%" fontSize="4">
              23½
            </text>
            <text x="71%" y="53%" fontSize="4">
              11.
            </text>
            <text x="76%" y="53%" fontSize="4">
              23½
            </text>
            <text x="71%" y="56%" fontSize="4">
              12.
            </text>
            <text x="76%" y="56%" fontSize="4">
              23½
            </text>

            <text x="71%" y="59%" fontSize="4">
              13.
            </text>
            <text x="76%" y="59%" fontSize="4">
              22
            </text>
            <text x="71%" y="62%" fontSize="4">
              14.
            </text>
            <text x="76%" y="62%" fontSize="4">
              24¼
            </text>
          </svg>
          {/* Sidebar Info Panel */}
          {showPlotDetail && selectedPlotData && (
            <div className="d-flex align-items-center justify-content-center">
              <div
                className="card shadow-sm ms-3 p-3"
                style={{
                  width: "300px",
                  height: "fit-content",
                  backgroundColor: "white",
                  border: "0",
                }}
              >
                <h5 className="card-title text-center text-success">
                  Plot Details
                </h5>
                <div className="card-body p-2">
                  <p className="mb-1">
                    <strong>Plot ID:</strong> {selectedPlotData.id}
                  </p>
                  <p className="mb-1">
                    <strong>Status:</strong> {selectedPlotData.status}
                  </p>
                  <p className="mb-1">
                    <strong>Top:</strong> {selectedPlotData.sides.top}
                  </p>
                  <p className="mb-1">
                    <strong>Right:</strong> {selectedPlotData.sides.right}
                  </p>
                  <p className="mb-1">
                    <strong>Bottom:</strong> {selectedPlotData.sides.bottom}
                  </p>
                  <p className="mb-1">
                    <strong>Left:</strong> {selectedPlotData.sides.left}
                  </p>
                </div>
                <button
                  className="btn btn-success btn-sm"
                  onClick={() => setShowBookingForm(true)}
                >
                  Book Now
                </button>
              </div>
            </div>
          )}
          {showBookingForm && selectedPlotData && (
            <div
              className="modal fade show d-block bookingform"
              tabIndex="-1"
              onClick={() => setShowBookingForm(false)}
            >
              <div
                className="modal-dialog modal-dialog-centered"
                style={{
                  pointerEvents: "auto",
                  // Optional: Add shadow to make modal stand out
                  boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)",
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <div className="modal-content">
                  {/* Your existing modal content remains the same */}
                  <div className="modal-header">
                    <h5 className="modal-title">Booking Form</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setShowBookingForm(false)}
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body">
                    <form>
                      <h6 className="text-success">
                        Selected Plot: {selectedPlotData.id}
                      </h6>
                      <div className="pt-3">
                        <label className="form-label">Name</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="pt-3">
                        <label className="form-label">Email</label>
                        <input type="email" className="form-control" />
                      </div>
                      <div className="pt-3">
                        <label className="form-label">Contact No</label>
                        <input type="tel" className="form-control" />
                      </div>
                      <div className="pt-3">
                        <label className="form-label">Message</label>
                        <textarea className="form-control" />
                      </div>
                    </form>
                  </div>
                  <div className="modal-footer">
                    <button type="submit" className="btn btn-success">
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}{" "}
        </div>
      </div>
    </>
  );
};

export default PlotLayoutPage;
